import * as Tone from 'tone';

export class EffectsChain {
  constructor() {
    this.reverb = new Tone.Reverb({ decay: 3, wet: 0.3 });
    this.delay = new Tone.FeedbackDelay({ delayTime: 0.25, feedback: 0.35, wet: 0.2 });
    this.chorus = new Tone.Chorus({ frequency: 1.5, depth: 0.7, wet: 0 }).start();
    this.distortion = new Tone.Distortion({ distortion: 0.3, wet: 0 });
    this.phaser = new Tone.Phaser({ frequency: 0.5, octaves: 3, wet: 0 });

    // Chain: input → distortion → chorus → phaser → delay → reverb → output
    this.input = this.distortion;
    this.distortion.connect(this.chorus);
    this.chorus.connect(this.phaser);
    this.phaser.connect(this.delay);
    this.delay.connect(this.reverb);
    this.output = this.reverb;
  }

  connectInput(source) {
    source.connect(this.input);
  }

  connectOutput(dest) {
    this.output.connect(dest);
  }

  setReverb({ wet, decay }) {
    if (wet !== undefined) this.reverb.wet.setValueAtTime(wet, Tone.now());
    if (decay !== undefined) this.reverb.decay = decay;
  }

  setDelay({ wet, time, feedback }) {
    if (wet !== undefined) this.delay.wet.setValueAtTime(wet, Tone.now());
    if (time !== undefined) this.delay.delayTime.setValueAtTime(time, Tone.now());
    if (feedback !== undefined) this.delay.feedback.setValueAtTime(feedback, Tone.now());
  }

  setChorus({ wet, frequency, depth }) {
    if (wet !== undefined) this.chorus.wet.setValueAtTime(wet, Tone.now());
    if (frequency !== undefined) this.chorus.frequency.value = frequency;
    if (depth !== undefined) this.chorus.depth = depth;
  }

  setDistortion({ wet, amount }) {
    if (wet !== undefined) this.distortion.wet.setValueAtTime(wet, Tone.now());
    if (amount !== undefined) this.distortion.distortion = amount;
  }

  setPhaser({ wet, frequency, octaves }) {
    if (wet !== undefined) this.phaser.wet.setValueAtTime(wet, Tone.now());
    if (frequency !== undefined) this.phaser.frequency.value = frequency;
    if (octaves !== undefined) this.phaser.octaves = octaves;
  }

  dispose() {
    this.reverb.dispose();
    this.delay.dispose();
    this.chorus.dispose();
    this.distortion.dispose();
    this.phaser.dispose();
  }
}
